import { type Options } from '@glidejs/glide';

const DynamicShelf = () => {
  const $box = $('[data-dynamic-shelf-url]');

  async function getHtml(url) {
    const storageKey = `${url}-home-prateleira`;
    const localHTML = window.aguadecoco.helpers.storage.read(`${storageKey}`);
    if (localHTML) return localHTML;

    const response = await $.get(url);
    window.aguadecoco.helpers.storage.save(`${storageKey}`, response, 5);

    return response;
  }
  function loadProducts(element) {
    const width = $(window).width() || 0;
    const $element = $(element);
    const url = $element.attr('data-dynamic-shelf-url');
    const urlViewMore = $element.attr('data-dynamic-shelf-view-more-url') || '';

    try {
      getHtml(url).then(function (html) {
        const $html = $('<div />').html(html.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, ''));
        const $shelfs = $html.find('.shelf');
        const $shelfTitle = $shelfs.find('h2');

        $shelfTitle.addClass('home-title');
        $shelfTitle.wrap(`<div class="shelf-title-container ${urlViewMore ? 'has-link' : ''}"> </div>`);
        $shelfTitle.after(`<a href="${urlViewMore || ''}"> VER MAIS </a>`);

        $shelfs.find('.helperComplement').remove();

        $html.find('.productImage noscript').each((_, e) => {
          const $e = $(e);
          const $parent = $e.closest('.productImage');
          const title = $e.find('.shelf-body-name').text();
          // @ts-ignore
          $parent.html(window.aguadecocoFixImageShelf ? window.aguadecocoFixImageShelf($e.html(), title) : $e.html());
        });

        $element.html('');

        $shelfs.each(function (_, shelfBox) {
          const $shelfBox = $(shelfBox);
          const $ul = $shelfBox.find('> ul');
          const $li = $ul.find('li');
          $element.append($shelfBox);
          $element.addClass('shelf-loaded');

          $ul.addClass('glide__slides ');
          // $ul.attr('data-glide-el', 'track');

          $ul.wrapAll('<div class="glide__track" data-glide-el="track"> </div>');
          $li.addClass('glide__slide');

          $shelfBox.addClass('glide');

          $shelfBox.append(
            `<div class="glide__arrows" data-glide-el="controls">
            <button class="glide__arrow glide__arrow__nav glide__arrow--right" data-glide-dir=">"  style='--top:${-90000}vh'>next</button>
            <button class="glide__arrow glide__arrow__nav glide__arrow--left" data-glide-dir="<"  style='--top:${-90000}px'>prev</button>
          </div>
          <div class="glide__bullets glide__custom__bullets" data-glide-el="controls[nav]">${$li
            .map((i) => `<div class="glide__bullet glide__custom__bullet" data-glide-dir="=${i}">${i}</div>`)
            .get()
            .join('')}
          </div>
          `,
          );

          const config = {
            type: 'carousel',
            autoplay: 8000,
            perView: 4,
            perSwipe: '|',
            breakpoints: {
              1024: {
                type: 'slider',
                perView: 2,
                perSwipe: '|',
              },
            },
          } as unknown as Options;

          const top = $shelfBox.find('.productImage').height();
          $shelfBox.find('.glide__arrows > button').attr('style', `--top:${top}px`);

          const mountedSlider = window.aguadecoco.helpers.slider(shelfBox, config, true);
          $shelfBox.parent().removeClass('shelf-not-loaded');

          if (width <= 1204) {
            mountedSlider.update({
              peek: {
                before: 0,
                after: 50,
              },
            });
          }
        });
      });
    } catch (err) {
      $element.html('');
    }
  }

  $box.each((_, e) => {
    const $e = $(e);
    $e.data('lazyload-script', () => {
      loadProducts(e);
    });

    $e.addClass('lazyload');
    $e.html(window.aguadecoco.helpers.loader.getHtmlLoader('default'));
  });
};

DynamicShelf();

export default {};
